import { useEffect } from "react"

const DEFAULT_TITLE = "IntuiDesk"
const SEPARATOR = " | "

/**
 * Sets the browser document title. Restores default on unmount.
 * Falsy values are filtered out, so passing undefined during loading
 * gracefully falls back (e.g. "Matters | IntuiDesk" while loading).
 */
export function useDocumentTitle(...parts: (string | undefined | null | false)[]) {
  const joined = parts.filter(Boolean).join(SEPARATOR)

  useEffect(() => {
    document.title = joined ? `${joined}${SEPARATOR}${DEFAULT_TITLE}` : DEFAULT_TITLE

    return () => {
      document.title = DEFAULT_TITLE
    }
  }, [joined])
}
